/* ============================================================
   STREIQ — SR Side Menu JavaScript
   File: assets/sr-side-menu.js
   Loaded via: theme.liquid before </body>
   ============================================================ */

(function () {
  'use strict';

  var hamburgerBtn = document.getElementById('srHamburgerBtn');
  var sideMenu     = document.getElementById('srSideMenu');
  var overlay      = document.getElementById('srSideMenuOverlay');
  var closeBtn     = document.getElementById('srSideMenuClose');

  if (!hamburgerBtn || !sideMenu || !overlay) return;

  /* ── Open ── */
  function openMenu() {
    sideMenu.classList.add('open');
    overlay.classList.add('active');
    hamburgerBtn.classList.add('is-open');
    hamburgerBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    /* Focus the close button for accessibility */
    setTimeout(function () {
      closeBtn && closeBtn.focus();
    }, 380);
  }

  /* ── Close ── */
  function closeMenu() {
    sideMenu.classList.remove('open');
    overlay.classList.remove('active');
    hamburgerBtn.classList.remove('is-open');
    hamburgerBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    hamburgerBtn.focus();
  }

  /* ── Events ── */
  hamburgerBtn.addEventListener('click', openMenu);
  closeBtn && closeBtn.addEventListener('click', closeMenu);
  overlay.addEventListener('click', closeMenu);

  /* Close on Escape key */
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && sideMenu.classList.contains('open')) {
      closeMenu();
    }
  });

  /* ── Submenu Toggles ── */
  var subToggles = document.querySelectorAll('.sr-sub-toggle');
  subToggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var parentLi = this.closest('.sr-has-sub');
      if (!parentLi) return;

      /* Close other open submenus */
      document.querySelectorAll('.sr-has-sub.open').forEach(function (openLi) {
        if (openLi !== parentLi) openLi.classList.remove('open');
      });

      parentLi.classList.toggle('open');
      var isOpen = parentLi.classList.contains('open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });

})();
